module.exports = __webpack_public_path__ + "assets/images/customer-portal-icon-ai.svg";